/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { updateAdditionalQuestionDataSubtypeSchema } from './UpdateAdditionalQuestionDataSubtypeSchema'
import { updateAdditionalQuestionDataTypeSchema } from './UpdateAdditionalQuestionDataTypeSchema'

export const updateAdditionalQuestionDataSchema = z.object({
	label: z.string().optional(),
	type: updateAdditionalQuestionDataTypeSchema.optional(),
	subtype: updateAdditionalQuestionDataSubtypeSchema.nullable().optional(),
	validationRules: z.array(z.string()).nullable().optional(),
	options: z.array(
		z.object({
			id: z.string().nullable(),
			label: z.string(),
			position: z.number(),
			isDisqualifying: z.boolean().nullable().default(false),
			scoreValue: z.number().nullable(),
			consentType: z.string().nullable(),
		}),
	).nullable().optional(),
	position: z.number().nullable().optional(),
	targetScoreRanges: z.array(z.string()).nullable().optional(),
})

export type UpdateAdditionalQuestionDataSchema = z.infer<typeof updateAdditionalQuestionDataSchema>
